<template>
  <div class="col-sm-10 col-sm-offset-1">
    <radar-chart class="" :chartData="{labels: seznamPodskupin.map((el) => $options.filters.stripHtml($options.filters.pickTranslation(el.name))), 
      datasets: [{label: $t('pages.subgroups.coverage'), backgroundColor: 'rgba(0, 166, 90, 0.4)', borderColor: 'rgba(0, 166, 90)', pointBorderColor: 'rgba(0, 166, 90)',  
      data: points}]}" :options="{scale: {ticks: {min: -0.1, max: adminView ? Math.max(...points) : 1}, pointLabels: {fontSize: 13}}}"></radar-chart>
  </div>
</template>
  

<script>
import Radar from '@/charts/Radar.js'

export default {
  props: ['seznamPodskupin'],
  components: {
    'radar-chart': Radar
  },
  computed: {
    points () {
      if (this.adminView) {
        let arr = this.seznamPodskupin.map(el => (el.totalQuestionsCount))
        return arr
      } else {
        let arr = this.seznamPodskupin.map(el => (el.totalSolvedQuestionsCount) / el.totalQuestionsCount)
        arr = arr.map(el => Math.round(el * 100) / 100)
        return arr
      }
    },
    adminView () {
      return this.$route.meta.admin === true
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// SpiderChart.vue?51dbd2ac